/**
 * Sprava session-id (identifikator relace aktualni diskuze). Identifikator se
 * generuje na klientovi, uklada se do localstorage. Posila se ke kazdemu requestu
 * a pokud se klikne na obnovit, tak se vygeneruje novy.
 */
import React, { createContext, useCallback, useContext, useState } from 'react';

import { SESSION_ID_STORAGE_KEY } from '../constants/global';

interface ISessionId {
    sessionId?: string
    setSessionId: (sessionId?: string) => void
}

export type SessionIdType = ISessionId | undefined;

export const SessionIdContext = createContext<SessionIdType>(undefined);

export const useSessionId = () => {
    return useContext(SessionIdContext);
};

interface ISessionIdProps {
    children: any
}

function SessionId({ children }: ISessionIdProps) {
    const [sessionId, setSessionId] = useState<ISessionId['sessionId']>(sessionStorage.getItem(SESSION_ID_STORAGE_KEY) || undefined);

    const setSessionIdAndSave = useCallback(
        (session: typeof sessionId) => {
            if (session) sessionStorage.setItem(SESSION_ID_STORAGE_KEY, session);
            else sessionStorage.removeItem(SESSION_ID_STORAGE_KEY);

            setSessionId(session);
        },
        []
    );

    return (
        <SessionIdContext.Provider value={{ sessionId, setSessionId: setSessionIdAndSave }}>
            {children}
        </SessionIdContext.Provider>
    );
}

export default SessionId;
